<style scoped="scoped" lang="scss">
.org-chart-node-label-inner {
  font-size: 23px !important; // 设置树的默认字体
}

/* 设置树宽度 */
.org-chart-container {
  padding: 80px;
  display: flex;
  justify-content: center;
  // width: 1300px !important;
  // height: 630px !important;
  // display: flex !important;
  // align-items: center !important;
  // overflow: auto;
  // scrollbar-color: #515151 rgba(0, 0, 0, 0.1);
  // /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  // scrollbar-width: thin;
}
</style>
<style lang="scss">
.label-bg-blue {
  color: white;

  background: #419fff;
  color: #fff;
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"> </yi_curd_table>
    <!-- <el-col :span="1">&nbsp;</el-col> -->
    <!-- <div style="display: flex;justify-content: flex-end;padding-right: 50px;"> -->
    <p style="font-size: 12px;color: #909399;padding-left: 25px ;">
      <!-- <el-col :span="0.5">&nbsp;</el-col> -->
      {{ $t('zuzhijiagoushuoming') }}
    </p>
    <br />
    <!-- <el-col :span="0.3">&nbsp;</el-col> -->
    <p style="font-size: 12px;color: #909399;padding-left: 25px;">
      <!-- <el-col :span="1">&nbsp;</el-col> -->
      {{ $t('org_description_content') }}
    </p>
    <!-- <div style="display: flex;padding-right: 780px; width: 120%;"> -->
    <div style="display: flex;justify-content: space-between;align-items: center;">
      <vue-okr-tree :data="orgList" node-key="id" animate-name="okr-zoom-in-top" :label-class-name="renderLabelClass" :current-lable-class-name="renderCurrentClass" show-collapsable default-expand-all animate @node-click="handleNodeClick" :label-width="200"> </vue-okr-tree>
    </div>
    <!-- 默认弹出 : 编辑节点弹窗 -->
    <el-drawer :modal="false" :visible.sync="updateDrawer" :direction="direction" :with-header="false" :size="208">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <p style="color: #303133;padding: 20px 0px 10px 40px;font-size: 18px;">{{ $t('bianji') }}</p>
        <el-button type="text" @click="closeUpdateDrawer()" class="el-icon-close" style="margin-right: 40px;"> </el-button>
      </div>
      <div style="display: flex;justify-content: center;">
        <el-form style="width: 620px;" size="mini" :inline="true" :model="yt.editObj" class="demo-form-inline">
          <el-form-item :label="$t('shangjizuzhi')" class="noborder" label-width="80px">
            <el-input v-model="yt.editObj.superiorOrganizationName" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('zuzhibianma')" class="noborder" label-width="96px">
            <!-- {{yt.editObj.code}} -->
            <el-input v-model="yt.editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('zuzhimingcheng')" label-width="80px" required>
            <el-input size="mini" type="text" v-model="yt.editObj.name"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('youxianji')" label-width="95px" required>
            <yi_number_input :type="'number'" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex;justify-content: flex-end;padding-right: 50px;">
        <el-button :loading="organizationDeleteLoading" size="mini" @click="openDeleteMessageBox()" v-if="utils.checkPower('web_system_organization_delete')">{{ $t('shanchucijiedian') }} </el-button>
        <!-- <el-button size="mini" type="primary" @click="open">{{$t('shanchucijiedian')}}</el-button> -->
        <el-button :loading="store.state.global_loading" size="mini" @click="initAddOrg()" v-if="utils.checkPower('web_system_organization_ctrate')">
          {{ $t('zengjiaxiayiji') }}
        </el-button>
        <el-button :loading="organizationUpdateLoading" size="mini" @click="updateOrg()" type="primary" v-if="utils.checkPower('web_system_organization_update')">
          {{ $t('baocungenggai') }}
        </el-button>
      </div>
    </el-drawer>
    <!-- 新增节点弹窗 -->
    <el-drawer :visible.sync="addDrawer" :direction="direction" :with-header="false" :size="208" :show-close="true">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <p style="color: #303133;padding: 20px 0px 10px 40px;font-size: 18px;">{{ $t('xinzeng') }}</p>
        <el-button type="text" @click="closeAddDrawer()" class="el-icon-close" style="margin-right: 40px;"> </el-button>
      </div>
      <div v-if="yt.editObj.next" style="display: flex;justify-content: center;">
        <el-form style="" size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('shangjizuzhi')" class="noborder" label-width="75px"> <el-input :value="yt.editObj.name" disabled></el-input> </el-form-item><br />
          <el-form-item :label="$t('zuzhibianma')" required>
            <el-input type="text" v-model="yt.editObj.next.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zuzhimingcheng')" label-width="90px" required>
            <el-input size="mini" type="text" v-model="yt.editObj.next.name"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('youxianji')" label-width="90px" required>
            <yi_number_input :type="'number'" :start.sync="yt.editObj.next.priority"></yi_number_input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex;justify-content: flex-end;padding-right: 40px;">
        <el-button size="mini" @click="addDrawer = false">
          {{ $t('quxiao') }}
        </el-button>
        <el-button :loading="organizationAddLoading" size="mini" @click="addOrg(yt.editObj.next)" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/javascript">
import { VueOkrTree } from 'vue-okr-tree';
import 'vue-okr-tree/dist/vue-okr-tree.css';
export default {
  name: 'web_system_organization_index',
  components: {
    VueOkrTree
  },
  data() {
    return {
      updateDrawer: false,
      addDrawer: false,
      removeTip: false,
      direction: 'btt',
      orgList: [],
      addParams: {},
      organizationDeleteLoading: false,
      organizationAddLoading: false,
      organizationUpdateLoading: false
    };
  },
  created() {
    setTimeout(() => {
      this.getOrganizations();
    }, 300);
  },
  methods: {
    afterDelete() {
      this.getOrganizations();
      alert(this.$t('shuaxinwancheng'));
    },
    async getOrganizations() {
      let response = await this.http
        .get('web/setting/org/tree')
        .then(res => {
          this.orgList = res.data;
          alert(this.orgList.children.length);
          if (this.orgList.children.length == 0) {
            orgList.children = null;
          }
          return true;
        })
        .catch(error => {
          return false;
        });
    },
    renderLabelClass(node) {
      return 'label-class-blue';
    },
    renderCurrentClass(node) {
      return 'label-bg-blue';
    },
    handleNodeClick(data) {
      //复制元数据
      this.yt.editObj = this.utils.copy(data);
      this.updateDrawer = true;
    },
    deleteOrg() {
      let params = this.utils.copy(this.yt.editObj);
      this.http
        .post('/web/setting/org/delete', params)
        .then(res => {
          this.organizationDeleteLoading = false;
          //刷新组织架构列表
          let refresh = this.getOrganizations();
          if (refresh) {
            this.updateDrawer = false;
            this.addDrawer = false;
            this.utils.successMessage(this.$t('success'));
          }
        })
        .catch(error => {
          this.organizationDeleteLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    updateOrg() {
      this.organizationUpdateLoading = true;
      let params = this.utils.copy(this.yt.editObj);
      this.http
        .post('/web/setting/org/update', params)
        .then(res => {
          this.organizationUpdateLoading = false;
          //刷新组织架构列表
          let refresh = this.getOrganizations();
          if (refresh) {
            this.utils.successMessage(this.$t(res.msg));
          }
          this.updateDrawer = false;
        })
        .catch(error => {
          this.organizationUpdateLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    addOrg() {
      this.organizationAddLoading = true;
      let params = this.utils.copy(this.yt.editObj.next);
      this.http
        .post('/web/setting/org/create', params)
        .then(res => {
          this.organizationAddLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          //刷新组织架构列表
          let refresh = this.getOrganizations();
          if (refresh) {
            this.updateDrawer = false;
            this.addDrawer = false;
          }
        })
        .catch(error => {
          this.organizationAddLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    initAddOrg() {
      this.addDrawer = true;
      this.$set(this.yt.editObj, 'next', {
        parentId: this.yt.editObj.id,
        level: this.yt.editObj.level + 1
      });
      this.yt.editObj.next.priority = 1;
    },
    removeTipDialog() {
      this.removeTip = true;
    },
    closeUpdateDrawer() {
      this.updateDrawer = false;
    },
    closeAddDrawer() {
      this.addDrawer = false;
    },
    openDeleteMessageBox() {
      this.organizationDeleteLoading = true;
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), this.$t('jinggao'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          this.deleteOrg();
        })
        .catch(() => {})
      .finally(()=>{
        this.organizationDeleteLoading = false;
      });
    }
  }
};
</script>
